import React, { Component } from 'react'
import _ from 'lodash'
import utils from '../utils'
import { Link } from 'react-router-dom'
import { isLoginCheck, loadBillingContact, loadUser, saveBillingContact, saveUserInfo, listOrders, logout } from '../actions/actions'
import { getShoopingCart } from '../functions/shopping-cart'
import moment from 'moment'
import 'moment/locale/fr';
import config from "../actions/config"

var getPart = function(components, types) {
	var res = []
	_.forEach(types, type => {
		var val = _.find(components, c => _.find(c.types, t => t === type))
		if(val) {
			res.push(val.long_name)
		}
	})
	return res.join(" ")
}

var getSavedPlaceObject = function() {
	if (localStorage.currentAddress) {
		try {
			const addr = JSON.parse(localStorage.currentAddress)

			return addr
		} catch(e) {
			return undefined
		}
	}
}

class MyAccount extends Component {
	state = {
		view: "orders",
		profile: {},
		billingContact: {},
		showError: false,
		shoppingCart: this.transformShoppingCart(),
		place: this.getSavedPlace(),
		loading: true
	}

	componentWillMount = () => {
		isLoginCheck()
		.then(() => Promise.all([loadBillingContact(), loadUser()]))
		.then(data => {
			const currentAddress = getSavedPlaceObject()
			var billingContact = data[0]
			var profile = data[1]
			if( !billingContact.zipcode && !billingContact.city && currentAddress && currentAddress.address_components) {
				//On ajoute l'adresse de livraison comme adresse de facturation par défaut s'il n'est pas déjà présente dans le compte
				var delContact = {}
				var components = currentAddress.address_components
				delContact.address_line1 = getPart(components, ["street_number", "route"])
				delContact.zipcode = getPart(components, ["postal_code"])
				delContact.city = getPart(components, ["locality"])
				this.setState({
					billingContact: _.defaults(delContact, billingContact),
					profile: _.defaults(delContact, profile),
					loading : false
				})
			} else {
				this.setState({
					billingContact : billingContact,
					profile : profile,
					loading : false
				})
			}
		}).catch(err => {
			this.props.history.replace("/login?goto=myaccount/orders")
		})
	}
	componentWillUnmount = () => {
	    window.removeEventListener('scroll', this.handleScroll);
	}
	logOut = () => {
		logout().then( () => {
			this.props.history.replace("/login?goto=myaccount/orders")
		})
	}
	handleView = (view) => {
		if (view === "orders") {
			this.props.history.replace("/myaccount/orders")
		} else { 
			this.props.history.replace("/myaccount/profile")
		}
	}
	transformShoppingCart() {
		let shoppingCart = _.groupBy(getShoopingCart())

		return _.map(shoppingCart, (v, offer_id) => ({offer_id, quantity: _.size(v)}))
	}
	getSavedPlace() {
		const obj = getSavedPlaceObject()
		return obj && obj.formatted_address
	}
	
	render() {
		// loader en attendant de recevoir les informations du compte
		if(this.state.loading){
			return (
				<main id="account" className="ptxl tiny-ptl small-ptl w100 bgc--inverse flex-item-noshrink" role="main">
					<div>
						<div className="h100 mauto tiny-plm tiny-prm small-pll small-prl medium-pll medium-prl large-pll large-prl ptxl tiny-pbl small-pbl pbxl txtcenter">
							<span>Chargement en cours ...</span>
						</div>
					</div>
				</main>
			)
		}


		const { billingContact, profile } = this.state
		const userName = _.get(billingContact, "firstname")
		console.log("Contact Firstname = ", userName)

		let view = []
		let paramView = this.props.match && this.props.match.params && this.props.match.params.view ? this.props.match.params.view : "orders"
		console.log(">>> paramView : ", this.props)
		if(paramView === "orders") {
			view =	<Orders />

		} else {
			view =	<Contact billingContact={billingContact} profile={profile} place={this.getSavedPlace()} />
		}
		return (
			<main id="account" className="ptxl tiny-ptl small-ptl w100 bgc--inverse flex-item-noshrink" role="main">
				<div className="bgc--primary">
					<div className="mw1140p w100 h100 d-flex mauto tiny-plm tiny-prm small-pll small-prl medium-pll medium-prl large-pll large-prl ptxl tiny-pbl small-pbl pbxl">
						<section className="tiny-h40 w100 medium-w25 large-w25 extra-large-w25 prm tiny-pa0"></section>
						<section className="tiny-h60 w100 medium-w75 large-w75 extra-large-w75 tiny-pa0 small-pa0 plxl">
							<h1 className="h2-like u-secondary-bold"><span className="u-small">Bonjour {userName}</span></h1>
						</section>
					</div>
				</div>
				<div className="mw1140p w100 h100 d-flex mauto ptxl pbxl tiny-ptl tiny-pbl tiny-plm tiny-prm small-pll small-prl medium-pll medium-prl large-pll large-prl">
					<section className="tiny-h40 w100 medium-w25 large-w25 extra-large-w25 prm tiny-pa0 of-hidden bdr--t tiny-no-bd small-no-bd">
						{/*<p className="ma0 u-secondary-bold u-big ptm pbl tiny-pa0">Bonjour {userName}</p>*/}
						<nav>
							<ul className="d-flex unstyled ptm tiny-pts">
								<li id="orders" className={"w100 tiny-wauto small-w100 pbm pts prm tiny-pbs c-pointer" + (paramView === "orders" ? " u-bold" : "")} onClick={() => this.handleView("orders")}>
									<span className="prs">Commandes</span>
								</li>
								<li id="profile" className={"w100 tiny-wauto small-w100 pbm pts prm tiny-pbs c-pointer" + (paramView === "profile" ? " u-bold" : "")} onClick={() => this.handleView("profile")}>
									<span className="prs">Profil</span>
								</li>
								<li className="tiny-pb0 pbm pts c-pointer" onClick={this.logOut}>
									<Link to="/">Déconnexion</Link>
								</li>
							</ul>
						</nav>
					</section>
					<section className="tiny-h60 w100 medium-w75 large-w75 extra-large-w75 bgc--inverse">
						<hr className="w100 mtm mbl tiny-mts tiny-visible small-visible is-hidden"/>
						{view}
					</section>
				</div>
			</main>
		)
	}
}

class Contact extends Component {
	state = _.defaults({
		saving: false
		, showError: false
		, billingContact: this.props.billingContact
		, profile: this.props.profile
	})
	save = () => {
		const billingContact = this.state.billingContact
		const profile = this.state.profile

		if (!profile.firstname
			|| !profile.lastname
			|| !profile.phone
			|| !billingContact.firstname
			|| !billingContact.lastname
			|| !billingContact.email
			|| !billingContact.phone
			|| !billingContact.address_line1
			|| !billingContact.zipcode
			|| !billingContact.city
			|| !billingContact.country) {
			this.setState({showError: true, savingSuccess: undefined}, () => {
				if(document.querySelectorAll(".input--error")[0])
					document.querySelectorAll(".input--error")[0].scrollIntoView({behavior : "smooth", block : "center"})
			})
		} else {
			this.setState({saving: true, savingSuccess: undefined})
			Promise.all([saveBillingContact(billingContact), saveUserInfo(profile)])
			.then(this.setState({saving: false, savingSuccess: true}, () => {setTimeout(() => this.setState({savingSuccess: undefined}), 3000)}))
			.catch(() => this.setState({saving: false, savingSuccess: false}))
		}
	}
	changeProfileTitle = (e) => {
		this.setState({profile: _.assign(this.state.profile, {title : e.target.value})})
	}
	changeProfileFirstname = (e) => {
		this.setState({profile: _.assign(this.state.profile, {firstname: e.target.value})})
	}
	changeProfileLastname = (e) => {
		this.setState({profile: _.assign(this.state.profile, {lastname: e.target.value})})
	}
	changeProfilePhone = (e) => {
		this.setState({profile: _.assign(this.state.profile, {phone: e.target.value})})
	}
	changeBillingTitle = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {title : e.target.value})})
	}
	changeBillingFirstname = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {firstname: e.target.value})})
	}
	changeBillingLastname = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {lastname: e.target.value})})
	}
	changeBillingEmail = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {email: e.target.value})})
	}
	changeBillingPhone = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {phone: e.target.value})})
	}
	changeBillingAddress_line1 = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {address_line1: e.target.value})})
	}
	changeBillingAddress_line2 = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {address_line2: e.target.value})})
	}
	changeBillingZipcode = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {zipcode: e.target.value})})
	}
	changeBillingCity = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {city: e.target.value})})
	}
	changeBillingCountry = (e) => {
		this.setState({billingContact: _.assign(this.state.billingContact, {country: e.target.value})})
	}
	render() {
		const { showError } = this.state

		return (
			<div className="tiny-pa0 small-pa0 plxl">
				<div className="pbl mtt">
					<h1 className="h3-like">Profil</h1>
				</div>
				<form>
					<table>
						<tbody>
							<tr>
								<td className="tiny-w40"><span>Civilité <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<select className="w100" value={this.state.profile.title} onChange={this.changeProfileTitle}>
										<option value={10}>Mme</option>
										<option value={20}>Mr</option>
										<option value={30}>Autre</option>
									</select>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Prénom <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.profile.firstname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un prénom.</span></p>
									<input className={"w100" + (showError && !this.state.profile.firstname ? " input--error" : "")} type="text" value={this.state.profile.firstname || ''} onChange={this.changeProfileFirstname}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Nom <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.profile.lastname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un nom.</span></p>
									<input className={"w100" + (showError && !this.state.profile.lastname ? " input--error" : "")} type="text" value={this.state.profile.lastname || ''} onChange={this.changeProfileLastname}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Email <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.profile.email ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse mail.</span></p>
									<input className={"w100" + (showError && !this.state.profile.email ? " input--error" : "")} type="email" value={this.state.profile.email || ''} readOnly/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Téléphone <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.profile.phone ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un numéro de téléphone.</span></p>
									<input className={"w100" + (showError && !this.state.profile.phone ? " input--error" : "")} type='tel' value={this.state.profile.phone || ''} onChange={this.changeProfilePhone} />
								</td>
							</tr>
							<tr>
								<td colSpan="2"><h4 className="h4-like ptl pbs">Adresse de retrait des produits</h4></td>
							</tr>
							<tr>
								<td className="pbm" colSpan="2">{this.props.place}</td>
							</tr>
							<tr>
								<td colSpan="2"><h4 className="h4-like ptl pbs">Adresse de facturation</h4></td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Civilité <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<select className="w100" value={this.state.billingContact.title} onChange={this.changeBillingTitle}>
										<option value={10}>Mme</option>
										<option value={20}>Mr</option>
										<option value={30}>Autre</option>
									</select>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Prénom <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.firstname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un prénom.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.firstname ? " input--error" : "")} type="text" value={this.state.billingContact.firstname || ''} onChange={this.changeBillingFirstname}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Nom <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.lastname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un nom.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.lastname ? " input--error" : "")} type="text" value={this.state.billingContact.lastname || ''} onChange={this.changeBillingLastname}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Email <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.email ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse mail.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.email ? " input--error" : "")} type="email" value={this.state.billingContact.email || ''} onChange={this.changeBillingEmail}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Téléphone <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.phone ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un numéro de téléphone.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.phone ? " input--error" : "")} type='tel' value={this.state.billingContact.phone || ''} onChange={this.changeBillingPhone} />
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Numéro et nom de la voie <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.address_line1 ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.address_line1 ? " input--error" : "")} type="text" value={this.state.billingContact.address_line1 || ''} onChange={this.changeBillingAddress_line1}/>
								</td>
							</tr>
							<tr>
								<td><span>Complément d'adresse</span></td>
								<td className="tiny-w60 pts pbs">
									<input className="w100" type="text" value={this.state.billingContact.address_line2 || ''} onChange={this.changeBillingAddress_line2} />
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Code Postal <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.billingContact.zipcode ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un code postal.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.zipcode ? " input--error" : "")} type="number" value={this.state.billingContact.zipcode || ''} onChange={this.changeBillingZipcode}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Ville <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.billingContact.city ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une ville.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.city ? " input--error" : "")} type="text" value={this.state.billingContact.city || ''} onChange={this.changeBillingCity}/>
								</td>
							</tr>
							<tr>
								<td className="tiny-w40"><span>Pays <span className="color--primary-darken">*</span></span></td>
								<td className="tiny-w60 pts pbs">
									<p className={'color--primary-darken u-small italic' + (showError && !this.state.billingContact.country ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un pays.</span></p>
									<input className={"w100" + (showError && !this.state.billingContact.country ? " input--error" : "")} type="text" value={this.state.billingContact.country || ''} onChange={this.changeBillingCountry}/>
								</td>
							</tr>
							<tr>
								<td colSpan="2"><p className="ptm u-small u-italic color--primary-darken">* Informations obligatoires</p></td>
							</tr>
						</tbody>
					</table>
					<div className='d-flex flex-space-between mrs'>
						<div className="d-inbl flex-item-fluid lnr mtauto mbauto mrm txtright">
							{
								this.state.savingSuccess === true ?
									<span>Le profil a été mis à jour.</span>
								:
									[]
							}
							{
								this.state.savingSuccess === false ?
									<span>Erreur, le profil n'a pas pu être sauvé.</span>
								:
									[]
							}
						</div>
						<div className="d-inbl lnr mtauto mbauto mls">
							<button type='button' className='btn--secondary btn--big fr' disabled={this.state.saving} onClick={this.save}><span className="pll prl">Mettre à jour</span></button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

class Orders extends Component {
	state = {
		orders: []
	}

	componentDidMount() {
		listOrders().then(orders => this.setState({orders}))
	}

	getInvoicePath(order = {}) {
		if (order.invoice_path) {
			return config.appUrl + '/download/invoices/' + order.account_id + '/' + order.invoice_path
		}

		return null
	}

	render() {
		const { orders } = this.state
		console.log("Commandes = ", _.map(orders, this.getInvoicePath))

		if(_.size(orders) > 0) {
			return (
				<div className="tiny-pa0 small-pa0 plxl">
					<div className="pbl mtt">
						<h1 className="h3-like">Commandes</h1>
					</div>
					{
						_.map(orders, (order) => {
							//const status = order.ls_order_status
							const status = 30

							let status_text = status == "10" ? "En attente de validation" : status == "20" ? "Validée" : status == "30" ? "En cours de traitement" : "Livrée"
							const invoice_amount = order.invoice_amount
							const invoice_vat_amount = order.invoice_vat_amount
							const offers = order.offers
							//const price_ht = (_.find(offer.price, p => p.from <= quantity && (p.to && quantity <= p.to || !p.to)) || {price_ht: 0}).price_ht
							//const total = price_ht * quantity
							const total_ht = invoice_amount ? invoice_amount : _.sum(_.map(offers, offer => {
								const quantity = offer.quantity
								const price_ht = (_.find(offer.price, p => p.from <= quantity && ((p.to && quantity <= p.to) || !p.to)) || {price_ht: 0}).price_ht

								return price_ht * quantity
							}))
							const total_ttc = invoice_vat_amount ? total_ht + invoice_vat_amount : total_ht * 1.2

							return (
								<div key={"order_" + order.ls_order_id} className="pal mbl bgc--inverse bdra--m bd--t">
									<h2 className="h4-like pbs">Commande du {moment(order.date_cre).format('dddd DD MMMM YYYY')}</h2>
									<p><span className="u-small">{status_text}</span> {status === 50 ? <span className="u-secondary-bold u-big plm">{utils.printPrice(total_ttc) + '€'}</span> : false}</p>
									<div className="d-flex ptl">
										{ status > 30 ?	[
											<button className="btn--secondary h60p tiny-w100 tiny-ml0 tiny-mr0 mbm extra-large-mb0 mrl"><span className="color--inverse prm plm">Télécharger les images</span></button>
											,
											<span className="d-flex flex-item-noshrink extra-tiny-w100">
												<button className="btn--unstyled extra-tiny-w100 tiny-w50 mtm mbm extra-large-mb0 tiny-mr0 extra-large-mll mrl"><span className="d-inbl extra-tiny-w100 tiny-w100 color--primary-darken u-small txtcenter"><span className="lnr lnr-file-empty u-big mts mrs"></span>Télécharger la facture</span></button>
												<button className="btn--unstyled extra-tiny-w100 tiny-w50 mtm mbm extra-large-mb0 tiny-ml0 tiny-mr0 mll mrl"><span className="d-inbl extra-tiny-w100 tiny-w100 color--primary-darken u-small txtcenter"><span className="lnr lnr-bubble u-big mts mrs"></span>Donner mon avis</span></button>
											</span>
											] : []
										}
									</div>
								</div>
							)

						})
					}
				</div>
			)
		}

		return (
			<div className="h100 tiny-pa0 small-pa0">
				<div className="h100 flex-container">
					<h1 className="h3-like flex-item-center">Aucune commande</h1>
				</div>
			</div>
		)
	}
}

export default MyAccount


// WEBPACK FOOTER //
// ./src/components/MyAccount.js